<template>
  <div>
    <section class="resources-header">
      <div class="resources-header__title">{{ activePage.heading_text }}</div>
      <div class="resources-header__subtitle">{{ activePage.intro_text }}</div>
    </section>

    <section class="resources-btns">
      <v-btn
        target="_blank"
        href="https://brand.stjude.org/login.html"
        color="jude_lightred"
        class="btn-resource"
      >
        Brand Central Access
      </v-btn>
      <v-btn
        target="_blank"
        href="https://drive.google.com/file/d/1e1UD7Zqz2uJOcMg66tpLtke_djyPRGTy/view?usp=sharing"
        color="jude_lightred"
        class="btn-resource"
      >
        Brand Central Access Instructions
      </v-btn>
    </section>

    <section class="resources-list">
      <ArticleSection
        :section="resourceSection"
        v-for="resourceSection in resourceSections"
        :key="resourceSection.id"
        :maxPerRow="5"
      />
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ResourcesPage",
  metaInfo: {
    titleTemplate: "%s",
  },
  mounted() {
    this.setPageContext("resources", () => {
      this.fetchResources();
    });
  },
  methods: {
    async fetchResources() {
      await this.fetchResource("ArticleSection");
    },
  },
  computed: {
    ...mapState({
      resourceSections: (state) =>
        state.page.cache[state.page.active?.id]?.ArticleSection,
    }),
  },
};
</script>

<style scoped lang="scss">
.resources-header {
  background-color: #f5f5f5;
  padding: 54px 220px;
  text-align: center;

  &__title {
    font-weight: 800;
    font-size: 64px;
    line-height: 73px;
  }
  &__subtitle {
    font-size: 18px;
    line-height: 24px;
    margin-top: 15px;
  }
}

.resources-btns {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 60px 0 20px;
  > a {
    margin: 0 30px;
  }
}

.resources-list {
  background-color: white;
  padding: 0 120px 50px;
}

.article-section__header {
  padding-top: 0;
}

@media screen and (max-width: 960px) {
  .resources-header {
    padding: 54px 20px;
  }
  .resources-list {
    padding: 0;
  }

  .resources-btns {
    flex-direction: column;
    align-items: center;
    background: $jude-softgray;
    padding: 0 0 60px;
    margin: 0;
    > a {
      margin: 0;
      &:not(:last-child) {
        margin-bottom: 26px;
      }
    }

    &::v-deep {
      .v-btn:not(.v-btn--round).v-size--default.btn-resource {
        font-size: 16px;
        height: 36px;
        padding: 0 40px;
      }
    }
  }
}
</style>
